import Moment from 'moment';

export const getReceiptItemName = (orderData, cart, index) => {
    const items = Array.isArray(orderData?.items) ? orderData.items : [];
    const matchedItem = items.find(
        (item) => String(item?._id ?? '') === String(cart?.item_id ?? '')
    );

    return (
        matchedItem?.name ||
        items?.[index]?.name ||
        cart?.item_name ||
        'Unknown Item'
    );
};

export const formatReceiptDateTime = (value) => {
    if (!value) {
        return '';
    }

    const parsedDate = Moment(value);
    return parsedDate.isValid()
        ? parsedDate.format('Y-M-D HH:mm:ss')
        : String(value);
};

export const getReceiptPaymentStatusLabel = (statusOptions, value) =>
    statusOptions.find((option) => Number(option?.value) === Number(value))?.label || 'Unknown';
